import { useState } from 'react'
import { supabase } from '../supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleLogin() {
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError('아이디 또는 비밀번호가 올바르지 않습니다.')
    setLoading(false)
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f4f3f0', fontFamily:'Noto Sans KR, sans-serif' }}>
      <div style={{ background:'#fff', border:'1px solid #e5e3de', borderRadius:16, padding:'40px 36px', width:380, boxShadow:'0 4px 12px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:36, marginBottom:10 }}>🚛</div>
          <div style={{ fontSize:11, color:'#a09e99', letterSpacing:'0.06em', marginBottom:4 }}>특장차 관리 시스템</div>
          <div style={{ fontSize:20, fontWeight:700 }}>사내 포털 로그인</div>
        </div>

        {error && (
          <div style={{ background:'#fdeaea', color:'#b83030', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:14 }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom:16 }}>
          <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>이메일</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            placeholder="이메일 입력"
            style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', outline:'none', boxSizing:'border-box' }}
          />
        </div>

        <div style={{ marginBottom:20 }}>
          <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            placeholder="비밀번호 입력"
            style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', outline:'none', boxSizing:'border-box' }}
          />
        </div>

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{ width:'100%', padding:11, background:'#2d5a3d', color:'#fff', border:'none', borderRadius:8, fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}
        >
          {loading ? '로그인 중...' : '로그인'}
        </button>
      </div>
    </div>
  )
}